import { useEffect, useRef, useState } from "react";
import useServerTime from "./useServerTime";

interface IUseTimer {
  type: "increase" | "decrease";
  dueDate?: Date;
}

export default function useTimer({ type, dueDate }: IUseTimer): {
  watch: Date;
  timer: number;
  formattedTimer: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
  };
  isUpcoming: boolean;
} {
  const { serverTime, isLoading } = useServerTime();

  const intervalId = useRef<number | NodeJS.Timeout | null>(null);

  const [watch, setWatch] = useState<Date>(serverTime);
  const [timer, setTimer] = useState<number>(0);

  // 서버 시간 로드 완료 후 watch와 timer 초기값 동기화
  useEffect(() => {
    if (isLoading) return;

    setWatch(serverTime);

    if (dueDate) {
      const remaining = dueDate.getTime() - serverTime.getTime();
      setTimer(remaining > 0 ? remaining : 0);
    }
  }, [isLoading]);

  useEffect(() => {
    if (isLoading) return;

    intervalId.current = setInterval(() => {
      setWatch((prevWatch) => {
        const calcTime = type === "increase" ? 1000 : -1000;
        const nextTime = new Date(prevWatch.getTime() + calcTime);

        if (dueDate) {
          const remainingTime = dueDate.getTime() - nextTime.getTime();
          setTimer(remainingTime > 0 ? remainingTime : 0);
        }

        return nextTime;
      });
    }, 1000);

    return () => {
      if (intervalId.current) clearInterval(intervalId.current);
    };
  }, [type, dueDate, isLoading]);

  return {
    watch,
    timer,
    formattedTimer: {
      days: Math.floor(timer / (1000 * 60 * 60 * 24)),
      hours: Math.floor((timer / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((timer / (1000 * 60)) % 60),
      seconds: Math.floor((timer / 1000) % 60),
    },
    isUpcoming: dueDate ? dueDate.getTime() > watch.getTime() : false,
  };
}
